import { render, staticRenderFns } from "./returnClass.vue?vue&type=template&id=0e8a4e84&scoped=true&"
import script from "./returnClass.vue?vue&type=script&lang=js&"
export * from "./returnClass.vue?vue&type=script&lang=js&"
import style0 from "./returnClass.vue?vue&type=style&index=0&id=0e8a4e84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8a4e84",
  null
  
)

export default component.exports